import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter, Link} from 'react-router-dom';

class SidebarItem extends Component {
	render() {
		const {title, url, iconClass, location} = this.props;
		return (
			<li className={ (location.pathname === url) ? 'active' : '' }>
				<Link to={url}>
					<i className={iconClass}/> <span>{title}</span>
				</Link>
			</li>
		)
	}
}

SidebarItem.defaultProps = {
	iconClass: 'fa fa-circle-o'
};

SidebarItem.propTypes = {
	title: PropTypes.string.isRequired,
	url: PropTypes.string.isRequired,
	iconClass: PropTypes.string
};

export default withRouter(SidebarItem)